import React, { useCallback, useState, useEffect } from "react";
import { FaRegHeart, FaHeart } from "react-icons/fa6";
import { BiComment } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import "./PostActions.scss";
import { useUser } from "../../../hooks/useUser";
import LikesPanel from "../LikesPanel/LikesPanel";

const PostActions = ({ toggleLikePost, postId, isLiked, comments, isCommentsDisabled, likesCount, onCommentClick, vanityUrl, userId, post }) => {
    const navigate = useNavigate();
    const [isLikesPanelOpen, setIsLikesPanelOpen] = useState(false);
    const [prevLikesCount, setPrevLikesCount] = useState(likesCount);
    const [animateCounter, setAnimateCounter] = useState(false);
    const [countDirection, setCountDirection] = useState("");
    const [heartAnimation, setHeartAnimation] = useState("");
    const [likeInProgress, setLikeInProgress] = useState(false);
    const { users } = useUser();

    const handleOpenLikesPanel = () => {
        setIsLikesPanelOpen(true);
    };

    // Accept userId as a prop if available
    const onCommentSectionClick = useCallback(() => {
        if (!onCommentClick) return;
        onCommentClick(postId);
        navigate(`/community/posts/${vanityUrl}`, {
            state: { post_id: postId,
                ...(userId ? { userId } : {})
            }
        });

    }, [navigate, onCommentClick, postId]);

    const commentCount = typeof comments === 'number' ? comments : 0;

    useEffect(() => {
        if (likesCount !== prevLikesCount) {
            const isCountingUp = likesCount > prevLikesCount;
            setCountDirection(isCountingUp ? "up" : "down");
            setAnimateCounter(true);
            setTimeout(() => setAnimateCounter(false), 400);
            setPrevLikesCount(likesCount);
        }
    }, [likesCount, prevLikesCount]);

    const handleLikeAction = async () => {
        if (likeInProgress) return;
        setLikeInProgress(true);


        if (isLiked) {
            setHeartAnimation("unlike-animation");
        } else {
            setHeartAnimation("heart-beat");
        }

        await toggleLikePost(postId, isLiked);
        setTimeout(() => setHeartAnimation(""), 800);
        setLikeInProgress(false);

    };

    return (
        <>
            <div className="post-actions">
                <button
                    className={`like-button hover-brighten`}
                >                    <div className="icon-label" onClick={handleLikeAction}>{isLiked ?
                    <FaHeart className={heartAnimation || ""} size={20} style={{ fill: "#e91e63" }} /> :
                    <FaRegHeart className={heartAnimation || "animate-all"} size={20} style={{ fill: "#555" }} />}
                    </div><div onClick={handleOpenLikesPanel} className="likes-display">
                        {likesCount > 0 && (
                            <div className={"likes-text"}>
                                {likesCount === 1 ? (
                                    <>
                                        <span className={`number-container ${animateCounter ? (countDirection === "up" ? "number-animate-up" : "number-animate-down") : ""}`}>1</span> Like
                                    </>
                                ) : (
                                    <>
                                        <span className={`number-container ${animateCounter ? (countDirection === "up" ? "number-animate-up" : "number-animate-down") : ""}`}>{likesCount}</span> Likes
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </button>                {!isCommentsDisabled && (
                    <button onClick={onCommentSectionClick} className="comment-button hover-brighten">
                        <div className="icon-label"><BiComment size={20} className="animate-all" style={{ fill: "#555" }} /> {commentCount}</div>
                    </button>
                )}
            </div>

            <LikesPanel
                isOpen={isLikesPanelOpen}
                onClose={() => setIsLikesPanelOpen(false)}
                postId={postId}
                likesCount={likesCount}
            />
        </>
    );
};

export default PostActions;